// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d10a2b42","977":"000cb4b3"}[chunkId] + ".chunk.js";
};